import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDraftBailiff,
  unSnapDraftBailiff,
} from "store/bailiff/draft/bailiff/draft_bailiff.action";
import { setHighlight } from "store/bailiff/nav/nav.action";

//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);

  useEffect(() => {
    dispatch(snapDraftBailiff());
    return () => dispatch(unSnapDraftBailiff());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
